import React, { useEffect, useState } from "react";
import LoadingScreen from "../../Shared/LoadingScreen";
import OpenSnackbar from "../../Shared/OpenSnackbar";
import Table from "../../Shared/Table";
import { PrimaryButton } from "../../Shared/Buttons";
import { useHistory } from "react-router-dom";
import GetCustomers from "../../Store/Actions/GetCustomer-Action";
import { CustomerAction } from "../../Store/Reducers/Customer-reducer";
import { useDispatch, useSelector } from "react-redux";
import LoadMoreItems from "../../Shared/LoadMoreItemsScreen";
import { useErrorHandler } from "react-error-boundary";
import styles from "./styles.module.css";
import SearchComp from "../../Shared/GlobalSearch";
import axios from "axios";
const Customers = () => {
  const dispatch = useDispatch();
  const {
    customerData,
    loading,
    isLoaded,
    status,
    PaginationToken,
    loadMore,
    searching,
  } = useSelector((state) => state.Customer);
  const history = useHistory();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const ErrorHandler = useErrorHandler();
  const [snackbarDetails, setSnackbarDetails] = useState({
    message: "",
    type: "",
  });

  const handleSnackbarOpen = (message, type) => {
    let obj = {
      message,
      type,
    };
    setSnackbarDetails(obj);
    setSnackbarOpen(true);
  };
  useEffect(() => {
    if (!isLoaded) {
      dispatch(GetCustomers(PaginationToken));
      dispatch(CustomerAction.setIsLoaded(true));
    }
  }, [isLoaded]);

  useEffect(() => {
    if (status !== "") {
      ErrorHandler(() => {
        throw new Error(status);
      });
      handleSnackbarOpen(status, "errorDark");
    }
    return () => {
      setSnackbarOpen(false);
      setSnackbarDetails({
        message: "",
        type: "",
      });
    };
  }, [status]);
  let customers = customerData.map((item) => {
    return {
      ...item,
      cStatus: item.enabled ? "Active" : "Blocked",
    };
  });
  const searchCustomer = (token) => {
    dispatch(CustomerAction.setLoadMore(true));
    let postBody = { limit: 50, PaginationToken: token };
    axios
      .post(process.env.REACT_APP_API_URL + "customers/search", postBody)
      .then((res) => {
        dispatch(CustomerAction.setSearching(true));
        dispatch(CustomerAction.searchData(res.data));
        dispatch(CustomerAction.setLoading(false));
        dispatch(CustomerAction.setPaginationToken(res.data.PaginationToken));
      })
      .catch((err) => {
        // setLoading(false);
        // setSuggestion([]);
        dispatch(CustomerAction.setSearching(true));
        dispatch(CustomerAction.searchData([]));
        dispatch(CustomerAction.setPaginationToken(""));
        dispatch(CustomerAction.setLoadMore(false));
        console.log(err);
      });
  };
  const formatData = (data) => {
    let formattedData = data.map((item) => {
      let number = item.number ? item.number.toString() : "—";
      return {
        total_orders: item.total_orders ? parseInt(item.total_orders) : 0,
        number: item.number
          ? parseInt(number.slice(1, 1) + number.slice(2))
          : "—",
        cStatus: item.cStatus ? item.cStatus : "—",
        name: item.name ? item.name : "—",
        details: (
          <PrimaryButton
            testId={`customer_id_${item.customer_id}`}
            size="small"
            style={{ width: "100px" }}
            handleClick={() => history.push(`/customers/${item.customer_id}`)}
          >
            details
          </PrimaryButton>
        ),
      };
    });
    return formattedData;
  };

  const columns = [
    {
      name: "name",
      label: "Name",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "total_orders",
      label: "Total Orders",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "cStatus",
      label: "Status",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "number",
      label: "Number",
      options: {
        sort: true,
        filter: true,
      },
    },

    {
      name: "details",
      label: "Details",
      options: {
        sort: false,
        filter: false,
      },
    },
  ];
  const onTableChangeHandler = (action, tableState) => {
    const { page, rowsPerPage, data } = tableState;
    let diff = Math.abs(page * rowsPerPage - data.length);
    if (
      diff <= rowsPerPage &&
      PaginationToken.length > 2 &&
      (action === "changePage" || action === "changeRowsPerPage")
    ) {
      if (searching) {
        searchCustomer(PaginationToken);
        return;
      } else {
        dispatch(GetCustomers(PaginationToken));
        return;
      }
    }
  };
  return (
    <>
      {loading ? (
        <LoadingScreen loading={loading} />
      ) : (
        <>
          {loadMore && <LoadMoreItems loading={loadMore} />}
          <div className={styles.searchDiv}>
            <SearchComp
              endpoint={"customers/search"}
              options={false}
              caller={"customer_search"}
            />
          </div>
          <Table
            data={formatData(customers)}
            columns={columns}
            title="Customers"
            onTableChange={onTableChangeHandler}
          />
          {snackbarOpen && (
            <OpenSnackbar
              message={snackbarDetails.message}
              type={snackbarDetails.type}
              open={snackbarOpen}
              setOpen={setSnackbarOpen}
              vertical="bottom"
              horizontal="center"
            />
          )}
        </>
      )}
    </>
  );
};

export default Customers;
